import Backtop from './Backtop';


Backtop.install = function(Vue) {
  Vue.component(Backtop.name, Backtop);
};

export default Backtop;
